export enum MultilayerBagsLabels {
  type = "type",
  dimensions = "dimensions",
  color = "color",
  product = "product",
  print = "print",
}
